import { Injectable } from '@angular/core';
import { SvgEditExtension, SvgEditExtensionObject } from '@models/svg-edit-extension';
import { CanvasService } from './canvas.service';
import { CanvasInputMode, CanvasInputModeService } from './canvas-input-mode.service';
import { SelectedElementsService } from './selected-elements.service';

@Injectable({ providedIn: 'root' })
export class ButtonExtensionService implements SvgEditExtension {
    name: string = 'buttonExtension';

    constructor(private plugin: ButtonExtensionPlugin) {
        this.init = this.init.bind(this);
    }

    init(): SvgEditExtensionObject {
        this.bindMouseEvents();
        return this.plugin;
    }

    addEventListeners(foreignObject) {
        this.plugin.addEventListeners(foreignObject);
    }

    private bindMouseEvents() {
        return this.plugin.bindMouseEvents();
    }
}

@Injectable({ providedIn: 'root' })
class ButtonExtensionPlugin implements SvgEditExtensionObject {
    constructor(
        private canvasService: CanvasService,
        private inputMode: CanvasInputModeService,
        private selectedElementsService: SelectedElementsService
    ) {}

    callback(deps: any) {}

    bindMouseEvents() {
        document.addEventListener('mousedown', this.handleMouseDown.bind(this));
        document.addEventListener('mousemove', this.handleMouseMove.bind(this));
        document.addEventListener('mouseup', this.handleMouseUp.bind(this));
    }

    private handleMouseDown(event: MouseEvent) {}

    private handleMouseMove(event: MouseEvent) {}

    private handleMouseUp(event: MouseEvent) {
        if (this.inputMode.getMode() === CanvasInputMode.BUTTON) {
            const svgRoot = this.canvasService.getSvgRoot();
            if (event.target !== svgRoot) {
                return;
            }
            const canvas = this.canvasService.getCanvas();

            const rootSctm = this.canvasService.getSCTM();
            const pt = this.canvasService.transformPoint(event.clientX, event.clientY, rootSctm);
            const mouseX = pt.x;
            const mouseY = pt.y;

            const foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
            foreignObject.id = canvas.getNextId();
            foreignObject.setAttribute('x', mouseX.toString());
            foreignObject.setAttribute('y', mouseY.toString());
            foreignObject.setAttribute('type', CanvasInputMode.BUTTON);

            foreignObject.setAttribute('width', '56');
            foreignObject.setAttribute('height', '24');
            // foreignObject.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
            foreignObject.setAttribute('pointer-events', 'all');

            const button = document.createElement('button');
            button.setAttribute('buttonInput', 'true');
            button.style.height = '100%';
            button.style.width = '100%';
            button.style.display = 'flex';
            button.style.justifyContent = 'center';
            button.style.alignItems = 'center';
            button.style.gap = '2px';
            button.style.padding = '4px 8px';
            button.style.borderRadius = '2px';
            button.style.backgroundColor = '#9cb2fb';
            button.style.fontFamily = 'NotoSans-Medium';
            button.style.fontSize = '12px';
            button.style.border = 'none';
            button.innerHTML = 'Button';
            button.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');

            foreignObject.appendChild(button);

            const layer = svgRoot.querySelector('.layer');
            layer.appendChild(foreignObject);

            this.addEventListeners(foreignObject);
            canvas.addCommandToHistory(new canvas.history.InsertElementCommand(foreignObject));
            this.selectedElementsService.setSelectedElements([foreignObject]);
            this.inputMode.setMode(CanvasInputMode.SELECT);
        }
    }

    addEventListeners(foreignObject) {
        const buttonInput = foreignObject.querySelectorAll('[buttonInput="true"]')[0];

        const observer = new MutationObserver(() => {
            const newWidth = foreignObject.getAttribute('width');
            const newHeight = foreignObject.getAttribute('height');
            buttonInput.style.fontSize =
                'min(' + (Number(newHeight) / 4).toString() + 'px, ' + (Number(newWidth) / 8).toString() + 'px' + ')';
        });

        observer.observe(foreignObject, {
            attributes: true,
            attributeFilter: ['width', 'height'],
        });
    }
}
